import React from "react";

/**
 * Form primitives shared by every dialog and form. Tokens align with the
 * editorial palette (figures-* in light, brand-* warm graphite in dark).
 */

const baseInputCls = [
  "w-full bg-figures-wash/70 dark:bg-white/5",
  "border border-figures-rule dark:border-white/10 rounded-md",
  "px-3 py-2.5 text-sm",
  "text-figures-ink dark:text-brand-displayInv",
  "placeholder-figures-muted/70 dark:placeholder-brand-mutedInv/70",
  "focus:outline-none focus:ring-2 focus:ring-figures-accent/35 dark:focus:ring-brand-accentInv/40",
  "focus:border-figures-accent dark:focus:border-brand-accentInv",
  "transition",
].join(" ");

export function Field({ label, error, children }) {
  return (
    <label className="block">
      {label && (
        <span className="text-xs uppercase tracking-[0.16em] text-figures-muted dark:text-brand-mutedInv mb-1.5 block">
          {label}
        </span>
      )}
      {children}
      {error && (
        <span className="text-xs text-figures-accent dark:text-brand-accentInv mt-1 block">
          {error}
        </span>
      )}
    </label>
  );
}

export function Input({ className = "", ...props }) {
  return <input {...props} className={`${baseInputCls} ${className}`} />;
}

export function Textarea({ className = "", rows = 3, ...props }) {
  return <textarea {...props} rows={rows} className={`${baseInputCls} ${className}`} />;
}

export function Checkbox({ checked, onChange, label, name }) {
  return (
    <label className="flex items-start gap-2 cursor-pointer text-sm text-figures-body dark:text-brand-bodyInv">
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        className={[
          "mt-0.5 h-4 w-4 rounded-md",
          "border border-figures-rule dark:border-white/20",
          "text-figures-accent dark:text-brand-accentInv",
          "focus:ring-figures-accent/40 dark:focus:ring-brand-accentInv/40",
          "accent-figures-accent dark:accent-brand-accentInv",
        ].join(" ")}
      />
      <span>{label}</span>
    </label>
  );
}
